import { useEffect, useState } from "react";
import { isProPage } from "@/lib/clientHost";
import { useLocation } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { consentChoice, pageView, setConsent, startAnalytics } from "@/lib/analytics";

// Tracks every SPA route change + shows the opt-out cookie notice.
export const AnalyticsTracker = () => {
  const loc = useLocation();
  const [notice, setNotice] = useState(() => !consentChoice());
  useEffect(() => { startAnalytics(); }, []);
  useEffect(() => { pageView(); }, [loc.pathname]);
  if (!notice || loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/demo-")) return null;
  const choose = (ok) => { setConsent(ok); setNotice(false); };
  return (
    <div className="fixed bottom-3 left-3 right-3 z-[60] mx-auto flex max-w-xl items-center gap-3 rounded-2xl border border-[#27272A] bg-[#0f0f12]/95 p-3 text-xs text-zinc-300 shadow-2xl backdrop-blur sm:left-4 sm:right-auto" data-no-track data-testid="cookie-banner">
      <Cookie className="h-4 w-4 shrink-0 text-[#D4AF37]" />
      <p className="flex-1">We use first-party analytics cookies to improve {isProPage(loc.pathname) ? "MyNextBigMove.co" : "RPOPRO"}. No ads, no selling data. <a href="/privacy-promise" className="text-[#F3C649] hover:underline">Privacy</a></p>
      <button onClick={() => choose(false)} className="rounded-full border border-[#27272A] px-3 py-1 text-zinc-300 hover:text-white" data-testid="cookie-decline">Decline</button>
      <button onClick={() => choose(true)} className="rounded-full bg-[#D4AF37] px-3 py-1 font-semibold text-black" data-testid="cookie-ok">OK</button>
      <button onClick={() => setNotice(false)} aria-label="Close" className="text-zinc-500 hover:text-white" data-testid="cookie-close"><X className="h-3.5 w-3.5" /></button>
    </div>
  );
};
